export const GradingActionTypes = {
  LOAD: 'LOAD',
  UPDATE: 'UPDATE',
  IMPORT: 'IMPORT',
  UNDO: 'UNDO',
  RESET_HISTORY: 'RESET_HISTORY',
};

const copyRecords = (records) => records.map((record) => ({ ...record }));

export const gradingReducer = (state, { actionType, payload }) => {
  switch (actionType) {
    case GradingActionTypes.LOAD:
      return {
        current: copyRecords(payload.records),
        previous: [],
      };

    case GradingActionTypes.UPDATE:
      return {
        current: state.current.map((record) =>
          record.id === payload.record.id
            ? { ...record, ...payload.record }
            : record,
        ),
        previous: [...state.previous, { item: copyRecords(state.current) }],
      };

    case GradingActionTypes.IMPORT:
      return {
        current: copyRecords(payload.records),
        previous: [...state.previous, { item: copyRecords(state.current) }],
      };

    case GradingActionTypes.UNDO:
      if (!state.previous.length) return state;
      return {
        current: copyRecords(state.previous[state.previous.length - 1].item),
        previous: state.previous.slice(0, -1),
      };

    case GradingActionTypes.RESET_HISTORY:
      return {
        ...state,
        previous: [],
      };

    default:
      return state;
  }
};

export const initialGradingState = {
  current: [],
  previous: [],
};
